module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("THE CUTTER"), _c('br'), _vm._v("INCIDENT")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("How America’s First Polio Vaccine"), _c('br'), _c('br'), _vm._v("Led to the Growing Vaccine Crisis")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Paul A. Offit, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("M.D")]), _vm._v("."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Yale University Press    New Haven and London")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41818d98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/02title.vue
// module id = 60
// module chunks = 0